export default __webpack_public_path__ + "static/media/logo.ed24cf23.png";